// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"houses"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5 21V9.25L12 3L19 9.22222V21H5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M10.0003 15V21H14.0003V15H10.0003Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10.0003 21V15H14.0003V21H10.0003ZM10.0003 21C10.3133 21 9.64381 21 10.0003 21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 11L12 3L3 11M5 9.97606V21H19V9.95M7 6.75V4","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const HousesIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'houses',
    ref,
    icon: element,
  },
));

HousesIcon.displayName = 'HousesIcon';

export default HousesIcon;
